export const API_URL = 'https://api.ipify.org?format=json';
